import axios from 'axios'
import swal from 'sweetalert'
import router from '../router'
import {createUniqueId} from './util'
import { isAndroid, isWechat} from "./util";
import {removeToken,removeUser,getSessionId,setSessionId,getAnonoymousId,setAnonoymousId} from './localinfo'
const baseUrl = process.env.VUE_APP_apiBaseUrl;


const exceptUrls = [
	'/auth/weixin',
	'/auth/cbgc',
	'/auth/wxopen'
];

if (!getSessionId()){
	setSessionId(createUniqueId(32))
}
if (!getAnonoymousId()){
	setAnonoymousId(createUniqueId(32))
}

let sessionId = getSessionId(),
	anonoymousId = getAnonoymousId();

let request = axios.create({
	baseURL:baseUrl,
	timeout: 0,
	withCredentials: false,
});

function hasQuestionMark(url) {
	return url.split('?').length > 1
}

function addStatisticsCode(request) {
	let url = request.url;
	let baseUrl = request.baseURL;
	let pureUrl = url.split(baseUrl)[0];
	let hasQuestionMark = hasQuestionMark(pureUrl);
	console.log(getSessionId())
	console.log(getAnonoymousId())
}

request.interceptors.request.use(function (request) {
	// if(isAndroid() && !isWechat()){
	// 	let customUserAgent = "Mozilla/5.0 (Linux; Android 8.0.0; MI 5s Plus Build/OPR1.170623.032; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/71.0.3578.99 Mobile Safari/537.36 TheCover/5.0.0 (TheCover_5.0.0_android_35619205055658_appname)"
	// 	request.headers.common['Cbgc-Ross-Gorden'] = customUserAgent
	// }
	return request;
});

request.interceptors.response.use(function (response) {
	return response;
}, function (error) {
	let code = error.response.status;
	if(code === 401){
		// 权限不足，重新登录
		removeToken();
		removeUser();
		return swal({
			title:error.response.data.message || error.response.data.errors,
			icon:'warning',
			className:'cover-swal',
		}).then(function () {
			return Promise.reject(error.response);
		});
	}else if(code === 404){
		// 资源不存在
		router.push({path:'/'})
	}else if(code >= 400 && code<500){
		if( code == 403 && error.response.data.code == 141200){
			return swal({
				title:'提示',
				text:error.response.data.msg || error.response.data.message || error.response.data.errors,
				icon:'warning',
			}).then(function () {
				return Promise.reject(error.response);
			});
		}else {
			return swal({
				title:'提示',
				text:error.response.data.msg || error.response.data.message || error.response.data.errors,
				icon:'warning',
			}).then(function () {
				return Promise.reject(error.response);	
			});
		}
	}else {
		return Promise.resolve(error.response);
	}
});

export default request;

